/*
 * <card-color-thumbnails> — 商品カードのカラバリサムネイル。
 * マークアップは snippets/card-color-thumbnails.liquid が生成し、本要素はタップ時に
 *   1. カードのメイン画像を当該カラーのバリアント画像へ差し替え（srcset / width / height ごと）
 *   2. カードのリンク先を ?variant= 付きへ更新（PDP も選択カラーで開く連続性の担保）
 *   3. aria-pressed の付け替えと、ホバー用セカンダリ画像の抑止クラス切替
 * を行う。ファセット絞り込み（facets.js の innerHTML 置換）でもカスタムエレメントの
 * 自動アップグレードで再初期化されるため、追加の配線は不要。
 */
if (!customElements.get('card-color-thumbnails')) {
  customElements.define(
    'card-color-thumbnails',
    class CardColorThumbnails extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('click', this.onThumbnailClick);
      }

      onThumbnailClick(event) {
        const button = event.target.closest('button[data-variant-id]');
        if (!button || !this.contains(button)) return;
        event.preventDefault();

        const card = this.closest('.card-wrapper');
        if (!card) return;

        const mainImage = card.querySelector('.card__media .media > img');
        if (mainImage) {
          mainImage.setAttribute('srcset', button.dataset.imageSrcset);
          mainImage.setAttribute('src', button.dataset.imageSrc);
          mainImage.setAttribute('alt', button.dataset.imageAlt);
          if (button.dataset.imageWidth && button.dataset.imageHeight) {
            mainImage.setAttribute('width', button.dataset.imageWidth);
            mainImage.setAttribute('height', button.dataset.imageHeight);
          }
        }

        /* 元カラー以外を表示中は、ホバーのセカンダリ画像（元カラーの別アングル）が
           誤ったカラーを見せてしまうため抑止する */
        const media = card.querySelector('.card__media .media');
        if (media) {
          media.classList.toggle('media--color-swapped', !button.hasAttribute('data-original'));
        }

        const url = `${this.dataset.productUrl}?variant=${button.dataset.variantId}`;
        card.querySelectorAll('.card__heading a').forEach((link) => link.setAttribute('href', url));

        this.querySelectorAll('button[data-variant-id]').forEach((thumb) => {
          thumb.setAttribute('aria-pressed', thumb === button ? 'true' : 'false');
        });
      }
    }
  );
}
